import * as actionTypes from './action-types';
import { GroupType } from 'utils/types';

export const changeGroupName = (value: string) => ({
  type: actionTypes.GROUP_NAME_CHANGE,
  payload: value,
});

export const move = (step) => ({
  type: actionTypes.MOVE,
  payload: step,
});

export const open = () => ({
  type: actionTypes.OPEN,
});

export const openEdit = (groupId: string, groupType: GroupType) => ({
  type: actionTypes.OPEN_EDIT,
  payload: { groupId, groupType },
});

export const requestSave = () => ({
  type: actionTypes.SAVE_REQUEST,
});

export const setError = (error) => ({
  type: actionTypes.ERROR_SET,
  payload: error,
});

export const setGroupType = (groupType: GroupType) => ({
  type: actionTypes.GROUP_TYPE_SET,
  payload: groupType,
});

export const setShow = (payload) => ({
  type: actionTypes.SHOW,
  payload,
});

export const setGroup = (group: any) => ({
  type: actionTypes.SET_GROUP,
  payload: group,
});

export const setCurrentStep = (value: number) => ({
  type: actionTypes.CURRENT_STEP_SET,
  payload: value,
});

export const previous = (currentStep: number) => ({
  type: actionTypes.PREVIOUS,
  payload: currentStep - 1,
});

export const finishCreation = () => {
  return { type: actionTypes.CREATE_GROUP_FINISH };
};

export const resetModal = () => {
  return { type: actionTypes.RESET };
};
